<template>
  <div>
    <div class="home-input">
      <div class="input-left">
        <div class="input-top" @click="chooseValue">
          {{currentValueComputed}}
          <img src="../assets/images/arrow.png" />
        </div>
        <!-- <div class="input-down">{{formateDate}}{{week}}</div> -->
      </div>
      <!-- cityList开始 -->
      <div class="pull-site" v-if="pull&&isCityList">
        <div class="site-head">
          <span @click="chooseProvince">{{currentProvince}}省份</span> >
          <span @click="handleProvince(this.currentProvince)">{{currentValueComputed}}城市</span>
        </div>
        <div class="site-body">
          <span
            v-if="isProvince"
            class="area-words"
            v-for="(site,index) in sites"
            :key="index"
            @click="handleProvince(site.name)"
          >{{ site.name }}省份</span>
          <span
            v-if="!isProvince"
            class="area-words"
            v-for="(site,index) in sites"
            :key="index"
            @click="handleSite(site.name)"
          >{{ site.name }}城市</span>
        </div>
        <div class="site-foot">
          <span class="foot-word">计量监督司全国服务：{{currentProvince}} - {{currentValueComputed}}</span>
          <div class="foot-button" @click="chooseValue">确定</div>
        </div>
      </div>
      <!-- cityList结束 -->
      <!-- defaultList开始 -->
      <default-list v-show="defaultBool" :currentValue='currentValueComputed' :listData="listData" @changeValue="changeValue"></default-list>
      <!-- defaultList结束 -->
    </div>
  </div>
</template>

<script>
import defaultList from './defaultList';
export default {
  name: 'filterList',
  components: {
    defaultList
  },
  props: {
    listData: Array, // 首页
    isCityList: Boolean, // city
    currentValue: {
      default: '计量',
      type: String
    }
  },
  data () {
    return {
      pull: false,
      defaultBool: false,
      currentProvince: '浙江',
      isProvince: true,
      week: '',
      formateDate: ''
      // currentValueComputed: ''
    };
  },
  methods: {
    chooseValue () {
      this.pull = !this.pull;
      this.defaultBool = !this.defaultBool;
    },
    handleProvince (province) {
      this.currentProvince = province;
      this.isProvince = false;
    },
    handleSite (site) {
      // this.currentValueComputed = site;
    },
    chooseProvince () {
      this.isProvince = true;
      // this.currentValueComputed = '';
    },
    getWeekDate () {
      let now = new Date();
      let day = now.getDay();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let date = now.getDate();
      let weeks = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ];
      this.week = weeks[day];
      this.formateDate = year + '年' + month + '月' + date + '日';
    },
    changeValue (val) {
      // this.currentValueComputed = this.$store.state.currentFilterValue;
      this.defaultBool = false;
      this.$store.commit('saveActiveShow', '')
      this.$emit('changeFilter', val)
    }
  },
  created () {
    this.getWeekDate();
  },
  mounted () {
    // this.currentValueComputed = this.currentValue
  },
  computed: {
    currentValueComputed () {
      return this.$store.state.currentFilterValue
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.input-left {
  padding: 28px 20px;
  display: inline-block;
  height: 96px;
  .input-top {
    cursor: pointer;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFangSC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    img {
      cursor: pointer;
    }
  }
  .input-down {
    line-height: 18px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    font-size: 12px;
    text-align: center;
  }
}
.pull-site {
  cursor: pointer;
  width: @body-width;
  height: 260px;
  background: #fff;
  box-shadow: 0px 8px 10px 0px rgba(0, 141, 255, 0.1);
  padding: 16px 40px;
  .site-head {
    font-size: 18px;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 24px;
  }
  .site-body {
    padding: 20px 20px 0 20px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
    .area-words {
      display: inline-block;
      margin-bottom: 20px;
      margin-right: 52px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
    }
    .area-words:hover {
      color: @color-base;
    }
  }
  .site-foot {
    line-height: 72px;
    position: relative;
    .foot-word {
      font-size: 16px;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      text-align: center;
      line-height: 72px;
    }
    .foot-button {
      display: inline-block;
      width: 100px;
      line-height: 48px;
      position: absolute;
      right: 6px;
      top: 14px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      background-color: @color-base;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/filterList.vue